<template>
  <div :class="['shop-languages', 'aside-item', { 'hidden': !otherLocales.length }]">
    <noindex><div class="aside-item-title">{{ $t('Акции и промокоды') }} {{ shop.name }} {{ $t('в других странах') }}</div></noindex>
    <div class="flags">
      <a :href="localeShopUrl(locale.locale)" v-for="locale in otherLocales" :key="locale.locale">
        <icon-flag-base width="30"><component :is="localesFlags[locale.locale]"/></icon-flag-base>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import IconFlagBase from '../icons/flags/IconFlagBase.vue';
import IconFlagBy from '../icons/flags/IconFlagBy.vue';
import IconFlagKz from '../icons/flags/IconFlagKz.vue';
import IconFlagRu from '../icons/flags/IconFlagRu.vue';
import IconFlagUa from '../icons/flags/IconFlagUa.vue';
import IconFlagBr from '../icons/flags/IconFlagBr.vue';
import IconFlagAu from '../icons/flags/IconFlagAu.vue';

export default {
  name: 'shop-languages',

  components: {
    IconFlagBase,
    IconFlagBy,
    IconFlagKz,
    IconFlagRu,
    IconFlagUa,
    IconFlagBr,
    IconFlagAu,
  },

  props: {
    shop: Object
  },

  data() {
    return {
      localesFlags: {
        'by': 'icon-flag-by',
        'kz': 'icon-flag-kz',
        'ru': 'icon-flag-ru',
        'ua': 'icon-flag-ua',
        'br': 'icon-flag-br',
        'au': 'icon-flag-au',
		'de': 'icon-flag-au',
      }
    };
  },

  computed: {
    ...mapState(['locales', 'currentLocale']),

    otherLocales() {
      if (this.shop.locales) {
        return this.locales.filter((item) => item.locale !== this.currentLocale.locale && this.shop.locales.includes(item.locale));
      } else {
        return [];
      }
    },

    localesUrls() {
      return this.locales.reduce((acc, item) => Object.assign(acc, { [item.locale]: item.href }), {});
    }
  },

  methods: {
    localeShopUrl(locale) {
      return `${this.localesUrls[locale]}${locale === 'ru' ? 'shop/' : ''}${this.shop.slug}/`;
    }
  }
};
</script>

<style scoped>
  .flags {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flags a {
    margin-right: 10px;
    cursor: pointer;
  }

  .flags a:last-child {
    margin-right: 0;
  }
</style>
